var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8004 4.1996C21.6673 4.06653 21.501 4 21.3014 4C21.1018 4 20.9355 4.06653 20.8024 4.1996L7.42914 17.5729L3.07119 13.2149C2.93812 13.1262 2.78288 13.0929 2.60546 13.1151C2.45021 13.1373 2.31714 13.2038 2.20625 13.3147C2.09536 13.4256 2.02883 13.5697 2.00665 13.7472C1.98448 13.9024 2.01774 14.0466 2.10645 14.1796L6.96341 19.0366C7.09647 19.1697 7.25172 19.2362 7.42914 19.2362C7.62874 19.2362 7.79508 19.1697 7.92814 19.0366L21.8004 5.16434C21.9335 5.03127 22 4.87603 22 4.6986C22 4.499 21.9335 4.33267 21.8004 4.1996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/Confirm.59b092bea0cb435c8884e66fc42e4e83.svg";
export { ForwardRef as ReactComponent };